function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M474.332 85.332C474.332 123.625 443.293 154.668 405 154.668C366.707 154.668 335.668 123.625 335.668 85.332C335.668 47.043 366.707 16 405 16C443.293 16 474.332 47.043 474.332 85.332Z",
  fill: "white"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M405 170.668C357.938 170.668 319.668 132.395 319.668 85.332C319.668 38.2734 357.938 0 405 0C452.062 0 490.332 38.2734 490.332 85.332C490.332 132.395 452.062 170.668 405 170.668ZM405 32C375.582 32 351.668 55.9375 351.668 85.332C351.668 114.73 375.582 138.668 405 138.668C434.418 138.668 458.332 114.73 458.332 85.332C458.332 55.9375 434.418 32 405 32Z",
  fill: "white"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M474.332 426.668C474.332 464.957 443.293 496 405 496C366.707 496 335.668 464.957 335.668 426.668C335.668 388.375 366.707 357.332 405 357.332C443.293 357.332 474.332 388.375 474.332 426.668Z",
  fill: "white"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M405 512C357.938 512 319.668 473.727 319.668 426.668C319.668 379.605 357.938 341.332 405 341.332C452.062 341.332 490.332 379.605 490.332 426.668C490.332 473.727 452.062 512 405 512ZM405 373.332C375.582 373.332 351.668 397.27 351.668 426.668C351.668 456.062 375.582 480 405 480C434.418 480 458.332 456.062 458.332 426.668C458.332 397.27 434.418 373.332 405 373.332Z",
  fill: "white"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M175.668 256C175.668 294.293 144.625 325.332 106.332 325.332C68.043 325.332 37 294.293 37 256C37 217.707 68.043 186.668 106.332 186.668C144.625 186.668 175.668 217.707 175.668 256Z",
  fill: "white"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M106.332 341.332C59.2734 341.332 21 303.062 21 256C21 208.938 59.2734 170.668 106.332 170.668C153.395 170.668 191.668 208.938 191.668 256C191.668 303.062 153.395 341.332 106.332 341.332ZM106.332 202.668C76.9141 202.668 53 226.602 53 256C53 285.398 76.9141 309.332 106.332 309.332C135.754 309.332 159.668 285.398 159.668 256C159.668 226.602 135.754 202.668 106.332 202.668Z",
  fill: "white"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M156.703 245.762C149.277 245.762 142.066 241.899 138.141 234.989C132.316 224.77 135.902 211.735 146.121 205.887L344.07 93.0354C354.289 87.1682 367.324 90.7541 373.172 101.012C378.996 111.231 375.41 124.266 365.191 130.114L167.238 242.965C163.91 244.864 160.285 245.762 156.703 245.762Z",
  fill: "white"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M354.633 421.762C351.047 421.762 347.422 420.863 344.094 418.965L146.141 306.113C135.922 300.289 132.34 287.254 138.164 277.012C143.965 266.773 157.02 263.168 167.262 269.035L365.215 381.887C375.434 387.711 379.016 400.746 373.191 410.988C369.246 417.898 362.035 421.762 354.633 421.762Z",
  fill: "white"
});

var SvgAlumni = function SvgAlumni(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAlumni, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/alumni.1d32db9b.svg";
export { ForwardRef as ReactComponent };